module.exports = __webpack_public_path__ + "img/McLarenLogo.32b66cd5.svg";